import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import ScheduledMessagesAPI from '../../api/scheduledMessages';

const state = {
    records: [],
    uiFlags: {
        fetchingList: false,
        creatingItem: false,
        updatingItem: false,
        deletingItem: false,
    },
};

const getters = {
    getScheduledMessages(_state) {
        return _state.records;
    },
    getScheduledMessagesUIFlags(_state) {
        return _state.uiFlags;
    },
};

const actions = {
    getScheduledMessages: async function getScheduledMessages(
        { commit },
        params = {}
    ) {
        commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
            fetchingList: true,
        });
        try {
            const response = await ScheduledMessagesAPI.get(params);
            commit(types.default.SET_SCHEDULED_MESSAGES, response.data);
        } catch (error) {
            // Ignore
        } finally {
            commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
                fetchingList: false,
            });
        }
    },

    createScheduledMessage: async function createScheduledMessage(
        { commit },
        data
    ) {
        commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
            creatingItem: true,
        });
        try {
            const response = await ScheduledMessagesAPI.create(data);
            commit(types.default.ADD_SCHEDULED_MESSAGE, response.data);
            return response.data;
        } catch (error) {
            return throwErrorMessage(error);
        } finally {
            commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
                creatingItem: false,
            });
        }
    },

    updateScheduledMessage: async function updateScheduledMessage(
        { commit },
        { id, ...data }
    ) {
        commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
            updatingItem: true,
        });
        try {
            const response = await ScheduledMessagesAPI.update(id, data);
            commit(types.default.EDIT_SCHEDULED_MESSAGE, response.data);
            return response.data;
        } catch (error) {
            return throwErrorMessage(error);
        } finally {
            commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
                updatingItem: false,
            });
        }
    },

    deleteScheduledMessage: async function deleteScheduledMessage(
        { commit },
        id
    ) {
        commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
            deletingItem: true,
        });
        try {
            await ScheduledMessagesAPI.delete(id);
            commit(types.default.DELETE_SCHEDULED_MESSAGE, id);
            return id;
        } catch (error) {
            return throwErrorMessage(error);
        } finally {
            commit(types.default.SET_SCHEDULED_MESSAGES_UI_FLAG, {
                deletingItem: false,
            });
        }
    },
};

const mutations = {
    [types.default.SET_SCHEDULED_MESSAGES_UI_FLAG](_state, data) {
        _state.uiFlags = {
            ..._state.uiFlags,
            ...data,
        };
    },
    [types.default.SET_SCHEDULED_MESSAGES]: MutationHelpers.set,
    [types.default.ADD_SCHEDULED_MESSAGE]: MutationHelpers.create,
    [types.default.EDIT_SCHEDULED_MESSAGE]: MutationHelpers.update,
    [types.default.DELETE_SCHEDULED_MESSAGE]: MutationHelpers.destroy,
};

export default {
    state,
    getters,
    actions,
    mutations,
};
